import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { PriceComparisonReport } from "../../../../components/modules/report/price-comparison";
import PriceComparisonReportMiddleware from "../../../../middleware/modules/report/price-comparison";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
import PriceComparisonSelling from "../../../../components/modules/report/price-comparison/selling";
// middlewares
const mapStateToProps = ({ priceComparisonReport }) => ({
  isProcessing: priceComparisonReport.isProcessing,
  isError: priceComparisonReport.isError,
  errorMessage: priceComparisonReport.errorMessage,
  dataSelling: priceComparisonReport.dataSelling,
  helper:priceComparisonReport.helperPriceComparisonReport,
  loading:priceComparisonReport.loadingDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getHelper:()=>PriceComparisonReportMiddleware.getHelper(),
      reset: () =>PriceComparisonReportMiddleware.reset(),
      getDataSelling:(post)=>PriceComparisonReportMiddleware.getDataSelling(post),
    },
    dispatch
  );
};
class PriceComparisonSellingContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    dataSelling: PropTypes.object,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.reset();
    this.props.getHelper();
  }
  
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Price Comparison Report")}
          </title>
        </Helmet>
      <PriceComparisonSelling
        {...this.props}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceComparisonSellingContainer);
